import React from 'react';

import { Pagination, Progress } from 'antd';

import { PaginationContainer } from '../../../../components/PaginationContainer';
import { Spinner } from '../../../../components/Spinner/Spinner';

import { Status, Table, TableWrapper } from './styles';

import {
  Invoice,
  InvoicePosition,
  pallets,
} from '../../../../Interfaces/HomeInterface';

interface TableProps {
  invoices: Invoice[];
  loading: boolean;
  page: number;
  total: number;
  handleChangePage: Function;
  setInvoice: Function;
  setShowOrderDetails: Function;
}

export const TableComponent: React.FC<TableProps> = ({
  invoices,
  loading,
  page,
  total,
  handleChangePage,
  setInvoice,
  setShowOrderDetails,
}) => {
  const renderPositions = (pallets: pallets[]) => {
    if (!pallets) return;

    return pallets.map(({ position }, index) => {
      return (
        <p className="table_position" key={index}>
          {position && position.position}
        </p>
      );
    });
  };

  const renderInvoices = () => {
    const orderedInvoices = invoices.sort((a, b) => {
      const date1 = new Date(a.created_at).getTime();
      const date2 = new Date(b.created_at).getTime();

      return date2 - date1;
    });

    const handleClick = (invoice: Invoice) => {
      setInvoice(invoice);
      setShowOrderDetails(true);
    };

    return orderedInvoices.map(
      (
        {
          collection_orders,
          invoice_operators,
          invoice_progress,
          shipping_company,
          invoice_number,
          order_number,
          client_name,
          created_at,
          route_item,
          pallets,
          cubage,
          user,
        },
        index,
        item,
      ) => {
        const date = new Date(created_at).toLocaleDateString('pt-BR');
        const time = new Date(created_at).toLocaleTimeString('pt-BR');

        const operator =
          invoice_operators &&
          invoice_operators.find(
            (findOperator) => findOperator.step === 'Motorista',
          );

        const driver = operator
          ? operator?.user?.individual_person?.name
          : route_item?.truck_route?.driver?.individual_person?.name;

        const truck =
          collection_orders?.[0]?.collection_information?.truck?.name ||
          route_item?.truck_route?.truck?.name;

        return (
          <tr
            className="table__order-info"
            key={index}
            onClick={() => {
              handleClick(item[index]);
            }}
          >
            <td data-label="Data da criação">
              {date} {time}
            </td>

            <td data-label="Nº do Pedido">{order_number}</td>

            <td data-label="Nº da Nota">{invoice_number}</td>

            <td data-label="Nome do Cliente">{client_name}</td>

            <td data-label="Nome da Transportadora">{shipping_company}</td>

            <td data-label="Cubagem (m3)">{Number(cubage).toFixed(2)}</td>

            <td data-label="Posição">{renderPositions(pallets)}</td>

            <td data-label="Usuário">
              {user?.individual_person?.name || user?.legal_person?.name}
            </td>

            <td data-label="Caminhão">{truck}</td>

            <td data-label="Motorista">{driver}</td>

            <td data-label="Status">
              {invoice_progress.length > 0 && (
                <Status
                  status={
                    invoice_progress?.[invoice_progress?.length - 1]
                      ?.invoice_status?.name
                  }
                >
                  {/* <Progress percent={50} showInfo={false} /> */}
                  {
                    invoice_progress?.[invoice_progress?.length - 1]
                      ?.invoice_status?.name
                  }
                </Status>
              )}
            </td>
          </tr>
        );
      },
    );
  };

  return (
    <>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th>Data criação</th>

              <th>Nº do Pedido</th>

              <th>Nº da Nota</th>

              <th>Nome do Cliente</th>

              <th>Nome da Transportadora</th>

              <th>Cubagem (m3)</th>

              <th>Posição</th>

              <th>Usuário</th>

              <th>Caminhão</th>

              <th>Motorista</th>

              <th>Status</th>
            </tr>
          </thead>

          {!loading && <tbody>{renderInvoices()}</tbody>}
        </Table>
        <PaginationContainer>
          {!loading ? (
            <Pagination
              defaultCurrent={page}
              total={total}
              onChange={(e) => handleChangePage(e)}
              pageSize={10}
              showSizeChanger={false}
              hideOnSinglePage={true}
            />
          ) : (
            <Spinner />
          )}

          {invoices.length === 0 && !loading && 'Nenhum resultado encontrado'}
        </PaginationContainer>
      </TableWrapper>
    </>
  );
};
